module.exports = __webpack_public_path__ + "img/showcase-comparables-en-ca.0442556e.jpg";